import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { AuditoriaPropiedadCHeaderToolbar } from "./AuditoriaPropiedadCHeaderToolbar";

export const AuditoriaPropiedadCHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <AuditoriaPropiedadCHeaderToolbar />
            </div>
        </div>
    )
}